import api, { AppSearchData } from 'api'
import { AppGrid } from 'components/AppGridLayout/AppGrid'
import React, { Component } from 'react'

import { MetadataGrid } from '../../../api'
import { PageHandlerProps } from './PageDesiger'

export default class GridDesiger extends Component<PageHandlerProps> {
	state = { data: {} as MetadataGrid, appSearchDataList: [] as AppSearchData[] }
	componentDidMount = async () => {
		let { metadataId, application } = this.props
		let data = await api.modeling.appgrid.getOne({ id: metadataId, application })
		this.setState({ data })
	}
	render() {
		let { data, appSearchDataList } = this.state
		let { metadataId, application, id } = this.props
		if (JSON.stringify(data) === '{}') return ''

		return (
			<AppGrid
				{...data.appGridLayout}
				id={metadataId}
				application={application}
				appSearchDataList={[...appSearchDataList]}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/GridDesiger.tsx